import styled from "styled-components";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import DescriptionIcon from "@mui/icons-material/Description";
import EmailIcon from "@mui/icons-material/Email";
import resumePDF from "../static/resume-lei.pdf";

const FlexDiv = styled.div`
  display: flex;
  margin-bottom: 1%;
  gap: 1rem;
`;

const Icon = styled.svg`
  width: 100%;
  max-width: 30px;
  height: 30px;
  transition: fill 0.2s ease;

  :hover,
  :focus {
    fill: #7393b3;
  }
`;

const StyledLink = styled.a`
  border-radius: 4px;
  padding: 4px;
  transition: all 0.2s ease;

  :focus {
    outline: 2px solid #7393b3;
    outline-offset: 2px;
  }

  :hover {
    transform: translateY(-2px);
  }
`;

const TwitterIcon: React.FC = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
  </svg>
);

const Icons: React.FC = () => (
  <FlexDiv>
    <StyledLink
      href="https://github.com/imreallynameless"
      target="_blank"
      rel="noreferrer"
      aria-label="Visit Lei Wu's GitHub profile"
    >
      <Icon>
        <GitHubIcon />
      </Icon>
    </StyledLink>

    <StyledLink
      href="https://www.linkedin.com/in/leiwuhoo/"
      target="_blank"
      rel="noreferrer"
      aria-label="Visit Lei Wu's LinkedIn profile"
    >
      <Icon>
        <LinkedInIcon />
      </Icon>
    </StyledLink>

    <StyledLink
      href={resumePDF}
      target="_blank"
      rel="noreferrer"
      aria-label="Download Lei Wu's resume (PDF)"
    >
      <Icon>
        <DescriptionIcon />
      </Icon>
    </StyledLink>

    <StyledLink
      href="mailto:lw2002@hotmail.ca"
      target="_blank"
      rel="noreferrer"
      aria-label="Send email to Lei Wu"
    >
      <Icon>
        <EmailIcon />
      </Icon>
    </StyledLink>

    <StyledLink
      href="https://x.com/ujustgotleid"
      target="_blank"
      rel="noreferrer"
      aria-label="Visit Lei Wu's X (Twitter) profile"
    >
      <Icon>
        <TwitterIcon />
      </Icon>
    </StyledLink>
  </FlexDiv>
);

export default Icons;

